(function () {
  var page = document.querySelector('[data-cart-page]');
  if (!page) return;

  var i18nEl = document.getElementById('CartPageI18n');
  var i18n = {};
  if (i18nEl) {
    try {
      i18n = JSON.parse(i18nEl.textContent);
    } catch (e) {
      i18n = {};
    }
  }

  var lineBusy = false;
  var kundtypBusy = false;
  var leveransvalBusy = false;
  var form = page.querySelector('.tambur-cart-page__layout');
  var hasHemsleverans = page.getAttribute('data-cart-has-hemsleverans') === 'true';
  var giftCardOnly = page.getAttribute('data-gift-card-only') === 'true';
  var kundtypConfirmed = page.getAttribute('data-kundtyp-explicit') === 'true';

  function isSweden() {
    return page.getAttribute('data-country') === 'SE';
  }

  var cartTotal = parseInt(page.getAttribute('data-cart-total'), 10) || 0;

  function formatMoney(cents) {
    if (window.TamburFormatMoney) return window.TamburFormatMoney(cents);
    var amount = cents / 100;
    return (amount % 1 === 0 ? amount.toString() : amount.toFixed(2).replace('.', ',')) + ' kr';
  }

  function getShippingCents() {
    if (giftCardOnly) return 0;
    if (!isSweden()) return null;
    if (!kundtypConfirmed) return null;

    var leveransval = getLeveransval();
    if (leveransval === 'butik') return 0;

    var threshold = i18n.shipFreeThreshold || 100000;
    if (cartTotal >= threshold) return 0;

    if (hasHemsleverans) return i18n.shipHomeCents || 50000;

    if (getKundtyp() === 'foretag') return i18n.shipPaketCents || 6900;
    return i18n.shipOmbudCents || 6800;
  }

  function updateGrandTotal() {
    var row = page.querySelector('[data-cart-grand-total-row]');
    var span = page.querySelector('[data-cart-grand-total-value]');
    if (!row || !span) return;

    var shipCents = getShippingCents();
    if (shipCents === null) {
      row.hidden = true;
      return;
    }

    span.textContent = formatMoney(cartTotal + shipCents);
    row.hidden = false;
  }

  function updateShippingEstimate() {
    var span = page.querySelector('[data-cart-shipping-value]');
    if (!span) return;
    if (giftCardOnly || !isSweden()) {
      updateGrandTotal();
      return;
    }

    if (!kundtypConfirmed) {
      span.textContent = i18n.calculatedAtCheckout || 'Beräknas i kassan';
      span.classList.add('tambur-cart-page__muted');
      var lockedNote = page.querySelector('[data-cart-shipping-note]');
      if (lockedNote) lockedNote.hidden = true;
      updateGrandTotal();
      return;
    }

    var leveransval = getLeveransval();
    var kundtypVal = getKundtyp() || 'privat';
    var isForetag = kundtypVal === 'foretag';
    var threshold = i18n.shipFreeThreshold || 100000;
    var freeOverThreshold = cartTotal >= threshold;
    var value;

    if (leveransval === 'butik') {
      value = i18n.shipFree;
    } else if (freeOverThreshold) {
      value = i18n.shipFree;
    } else if (hasHemsleverans) {
      value = i18n.shipHome;
    } else if (isForetag) {
      value = i18n.shipPaket;
    } else {
      value = i18n.shipOmbud;
    }

    if (value) {
      span.textContent = value;
      span.classList.remove('tambur-cart-page__muted');
    }

    var note = page.querySelector('[data-cart-shipping-note]');
    if (note) {
      var showNote = leveransval !== 'butik' && !freeOverThreshold;
      if (showNote && i18n.shipFreeRemaining) {
        var remaining = threshold - cartTotal;
        var amountStr = window.TamburFormatMoney
          ? window.TamburFormatMoney(remaining)
          : ((remaining / 100) % 1 === 0 ? (remaining / 100).toString() : (remaining / 100).toFixed(2).replace('.', ',')) + ' kr';
        note.textContent = i18n.shipFreeRemaining.replace('__AMOUNT__', amountStr);
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    updateGrandTotal();
  }

  function setLoading(on) {
    page.classList.toggle('is-loading', on);
  }

  function refreshPage() {
    window.location.reload();
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function updateCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function getLeveransvalInput() {
    return page.querySelector('[data-cart-leveransval-input]');
  }

  function getKundtypInput() {
    return page.querySelector('[data-cart-kundtyp-input]');
  }

  function getLeveranssattInput() {
    return page.querySelector('[data-cart-leveranssatt-global]');
  }

  function getLeveransval() {
    if (!kundtypConfirmed) return 'leverans';
    var input = getLeveransvalInput();
    return input && input.value ? input.value : 'leverans';
  }

  function getKundtyp() {
    var input = getKundtypInput();
    return input && input.value ? input.value : '';
  }

  function getForetagNameInput() {
    return page.querySelector('[data-cart-foretag-name]');
  }

  function getOrgNrInput() {
    return page.querySelector('[data-cart-orgnr]');
  }

  function syncForetagFields() {
    var wrap = page.querySelector('[data-cart-foretag-fields]');
    if (!wrap) return;
    wrap.hidden = !kundtypConfirmed || getKundtyp() !== 'foretag';
  }

  function saveForetagAttributes() {
    var nameInput = getForetagNameInput();
    if (!nameInput) return Promise.resolve();
    var orgInput = getOrgNrInput();
    return updateCartAttributes({
      Företagsnamn: nameInput.value.trim(),
      Organisationsnummer: orgInput ? orgInput.value.trim() : ''
    });
  }

  function validateForetagBeforeCheckout() {
    if (getKundtyp() !== 'foretag') return true;
    var nameInput = getForetagNameInput();
    if (!nameInput || !nameInput.value.trim()) {
      syncForetagFields();
      var wrap = page.querySelector('[data-cart-foretag-fields]');
      if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (nameInput) nameInput.focus();
      return false;
    }
    return true;
  }

  // ---- Presentflöde (skickas till order som note_attributes) ----
  function getGiftWrap() {
    return page.querySelector('[data-cart-gift]');
  }

  function getGiftToggle() {
    return page.querySelector('[data-cart-gift-toggle]');
  }

  function isGiftOn() {
    var toggle = getGiftToggle();
    return !!(toggle && toggle.checked);
  }

  function syncGiftFlag() {
    var flag = page.querySelector('[data-cart-gift-flag]');
    if (flag) flag.value = isGiftOn() ? 'Ja' : '';
  }

  // Vart presenten tar vägen: 'ombud' (DHL Service point), 'butik' (hämtas hos
  // oss) eller 'adress' (leveransadressen i kassan — skrymmande gods, företag
  // och utländska order).
  function giftDeliveryState() {
    if (!isSweden()) return 'adress';
    if (kundtypConfirmed && getLeveransval() === 'butik') return 'butik';
    if (hasHemsleverans) return 'adress';
    if (kundtypConfirmed && getKundtyp() === 'foretag') return 'adress';
    return 'ombud';
  }

  function syncGiftHint() {
    var wrap = getGiftWrap();
    if (!wrap) return;
    var state = giftDeliveryState();
    var mobilState = state === 'butik' ? 'butik' : 'sms';

    wrap.querySelectorAll('[data-gift-hint]').forEach(function (el) {
      el.hidden = el.getAttribute('data-gift-hint') !== state;
    });
    wrap.querySelectorAll('[data-gift-mobil-hint]').forEach(function (el) {
      el.hidden = el.getAttribute('data-gift-mobil-hint') !== mobilState;
    });
    var optional = wrap.querySelector('[data-gift-mobil-optional]');
    if (optional) optional.hidden = state !== 'butik';
  }

  function collectGiftAttributes() {
    var on = isGiftOn();
    var namn = page.querySelector('[data-cart-gift-namn]');
    var mobil = page.querySelector('[data-cart-gift-mobil]');
    var epost = page.querySelector('[data-cart-gift-epost]');
    return {
      Present: on ? 'Ja' : '',
      'Present-namn': on && namn ? namn.value.trim() : '',
      'Present-mobil': on && mobil ? mobil.value.trim() : '',
      'Present-epost': on && epost ? epost.value.trim() : ''
    };
  }

  function saveGiftAttributes() {
    if (!getGiftWrap()) return Promise.resolve();
    return updateCartAttributes(collectGiftAttributes());
  }

  function validateGiftBeforeCheckout() {
    if (!getGiftWrap() || !isGiftOn()) return true;
    var namn = page.querySelector('[data-cart-gift-namn]');
    var mobil = page.querySelector('[data-cart-gift-mobil]');
    var errEl = page.querySelector('[data-cart-gift-error]');
    var missingNamn = !namn || !namn.value.trim();
    // Vid hämtning i butik skickas inget paket, så mottagaren aviseras inte.
    var missingMobil = giftDeliveryState() !== 'butik' && (!mobil || !mobil.value.trim());
    if (missingNamn || missingMobil) {
      if (errEl) {
        errEl.textContent = missingMobil
          ? i18n.giftRequiredError || 'Fyll i mottagarens namn och mobilnummer för presentleverans.'
          : i18n.giftNameRequiredError || 'Fyll i mottagarens namn.';
        errEl.hidden = false;
      }
      var target = missingNamn ? namn : mobil;
      if (target) target.focus();
      else {
        var wrap = getGiftWrap();
        if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    if (errEl) errEl.hidden = true;
    return true;
  }

  function initGiftFields() {
    var wrap = getGiftWrap();
    if (!wrap) return;
    var toggle = getGiftToggle();
    var fields = page.querySelector('[data-cart-gift-fields]');
    var errEl = page.querySelector('[data-cart-gift-error]');
    var inputs = wrap.querySelectorAll(
      '[data-cart-gift-namn],[data-cart-gift-mobil],[data-cart-gift-epost]'
    );

    function reflect() {
      if (fields) fields.hidden = !isGiftOn();
      syncGiftFlag();
      syncGiftHint();
    }

    if (toggle) {
      toggle.addEventListener('change', function () {
        // Rensa fälten när gåvan slås av — annars kan gamla värden posta vid
        // native submit och felaktigt styra DHL-aviseringen till mottagaren.
        if (!isGiftOn()) {
          Array.prototype.forEach.call(inputs, function (el) {
            el.value = '';
          });
        }
        reflect();
        if (errEl) errEl.hidden = true;
        saveGiftAttributes().catch(function () {
          /* tyst — sparas igen vid kassa */
        });
        if (isGiftOn()) {
          var namn = page.querySelector('[data-cart-gift-namn]');
          if (namn) namn.focus();
        }
      });
    }

    var saveTimer;
    function scheduleSave() {
      if (!isGiftOn()) return;
      if (errEl) errEl.hidden = true;
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        saveGiftAttributes().catch(function () {
          /* tyst — sparas igen vid kassa */
        });
      }, 400);
    }
    Array.prototype.forEach.call(inputs, function (el) {
      el.addEventListener('input', scheduleSave);
    });

    reflect();
  }

  // Spara både företags- och presentattribut inför JS-driven checkout
  function saveCheckoutExtraAttributes() {
    return Promise.all([saveForetagAttributes(), saveGiftAttributes()]);
  }

  function needsOmbud(kundtypVal, leveransval) {
    return leveransval === 'leverans' && !hasHemsleverans && kundtypVal === 'privat';
  }

  function setRequireOmbud(on) {
    page.setAttribute('data-require-dhl', on ? 'true' : 'false');
  }

  function getCheckoutSyncOpts(deliveryMethod) {
    var pageToken = page.getAttribute('data-storefront-token');
    var globalToken = window.TamburCheckout && window.TamburCheckout.storefrontToken;
    return {
      shop: page.getAttribute('data-shop-domain'),
      token: pageToken || globalToken,
      countryCode: page.getAttribute('data-country'),
      deliveryMethod: deliveryMethod
    };
  }

  function hasStorefrontToken() {
    return window.TamburCheckoutSync && window.TamburCheckoutSync.hasToken(getCheckoutSyncOpts());
  }

  function syncCheckoutPreference(method) {
    if (!window.TamburCheckoutSync) return Promise.resolve();
    return window.TamburCheckoutSync.sync(getCheckoutSyncOpts(method));
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function showOmbudRequired() {
    var dhl = document.getElementById('dhl-ombud');
    if (dhl) {
      dhl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var status = dhl.querySelector('[data-dhl-sp-status]');
      if (status) status.textContent = i18n.selectOmbud || 'Välj DHL ombud innan du går till kassan.';
    }
  }

  function toggleOmbudUi(showOmbud) {
    var pickerWrap = page.querySelector('[data-dhl-picker-wrap]');
    var dhlRoot = page.querySelector('#dhl-ombud');
    var hintHemsleverans = page.querySelector('[data-hint-hemsleverans]');

    page.classList.toggle('tambur-cart-page--no-ombud', !showOmbud);

    [pickerWrap, dhlRoot].forEach(function (el) {
      if (el) el.hidden = !showOmbud;
    });
    if (hintHemsleverans && hasHemsleverans) hintHemsleverans.hidden = false;
  }

  function resetDhlPickerUi() {
    var dhlRoot = page.querySelector('#dhl-ombud');
    if (!dhlRoot) return;

    dhlRoot.classList.remove('is-selected');

    var postal = dhlRoot.querySelector('[data-dhl-sp-postal]');
    if (postal) postal.value = '';

    var list = dhlRoot.querySelector('[data-dhl-sp-list]');
    if (list) list.innerHTML = '';

    var status = dhlRoot.querySelector('[data-dhl-sp-status]');
    if (status) status.textContent = '';

    var selected = dhlRoot.querySelector('[data-dhl-sp-selected]');
    if (selected) {
      selected.hidden = true;
      selected.textContent = '';
    }

    var ombudNamn = form && form.querySelector('input[name="attributes[DHL-ombud-namn]"]');
    var postalHidden = form && form.querySelector('input[name="attributes[DHL-postnr]"]');
    if (ombudNamn) ombudNamn.value = '';
    if (postalHidden) postalHidden.value = '';
  }

  function clearDhlAttributes() {
    return updateCartAttributes({
      'DHL-ombud': '',
      'DHL-ombud-namn': '',
      'DHL-postnr': '',
      'DHL-land': '',
      Leveranssätt: ''
    }).then(function () {
      var ombudInput = form && form.querySelector('[data-dhl-ombud-id]');
      var leveranssatt = getLeveranssattInput();
      if (ombudInput) ombudInput.value = '';
      if (leveranssatt) leveranssatt.value = '';
      resetDhlPickerUi();
    });
  }

  function staleDhlForMarket() {
    var market = (page.getAttribute('data-country') || 'SE').trim().toUpperCase();
    var ombudId = (page.getAttribute('data-dhl-saved-id') || '').trim();
    var land = (page.getAttribute('data-dhl-saved-land') || '').trim().toUpperCase();
    if (!ombudId) return false;
    if (land && land !== market) return true;
    if (!land && market !== 'SE') return true;
    return false;
  }

  function setLeveranssattUi(val) {
    var leveranssatt = getLeveranssattInput();
    if (!leveranssatt) return;
    if (val === 'butik') {
      var pickupAttr = leveranssatt.getAttribute('data-pickup-attribute');
      leveranssatt.value = pickupAttr || i18n.pickupAttribute || 'Hämta i butik';
    } else if (!form || !form.querySelector('[data-dhl-ombud-id]') || !form.querySelector('[data-dhl-ombud-id]').value) {
      leveranssatt.value = '';
    }
  }

  function syncKundtypPills() {
    var wrap = page.querySelector('[data-cart-kundtyp]');
    if (!wrap) return;
    var val = getKundtyp();
    wrap.querySelectorAll('[data-cart-kundtyp-val]').forEach(function (pill) {
      var pillVal = pill.getAttribute('data-cart-kundtyp-val');
      pill.classList.toggle('is-selected', kundtypConfirmed && pillVal === val);
    });
  }

  function syncLeveransvalPills() {
    var wrap = page.querySelector('[data-cart-leveransval]');
    if (!wrap) return;
    var val = getLeveransval();
    wrap.querySelectorAll('[data-cart-leveransval-val]').forEach(function (pill) {
      var pillVal = pill.getAttribute('data-cart-leveransval-val');
      pill.classList.toggle('is-selected', kundtypConfirmed && pillVal === val);
      pill.setAttribute('aria-disabled', kundtypConfirmed ? 'false' : 'true');
      if (kundtypConfirmed) {
        pill.removeAttribute('tabindex');
      } else {
        pill.setAttribute('tabindex', '-1');
      }
    });
    wrap.setAttribute('aria-disabled', kundtypConfirmed ? 'false' : 'true');
  }

  function setKundtypConfirmed(confirmed) {
    kundtypConfirmed = confirmed;
    var leveransBlock = page.querySelector('[data-cart-leveransval-block]');
    var hintPrompt = page.querySelector('[data-hint-kundtyp-prompt]');
    if (leveransBlock) leveransBlock.classList.toggle('is-locked', !confirmed);
    if (hintPrompt) hintPrompt.hidden = confirmed;
    if (!confirmed) {
      var levInput = getLeveransvalInput();
      if (levInput) levInput.value = '';
    }
    syncKundtypPills();
    syncLeveransvalPills();
    syncForetagFields();
    updateDeliveryUi();
  }

  function updateDeliveryUi() {
    updateShippingEstimate();
    syncGiftHint();
    if (!isSweden()) {
      page.classList.remove('tambur-cart-page--no-ombud');
      var intlPicker = page.querySelector('[data-dhl-picker-wrap]');
      var intlDhl = page.querySelector('#dhl-ombud');
      if (intlPicker) intlPicker.hidden = false;
      if (intlDhl) intlDhl.hidden = false;
      return;
    }

    if (!kundtypConfirmed) {
      toggleOmbudUi(false);
      setRequireOmbud(false);
      var hintButikLocked = page.querySelector('[data-hint-butik]');
      var hintForetagLocked = page.querySelector('[data-hint-foretag-leverans]');
      if (hintButikLocked) hintButikLocked.hidden = true;
      if (hintForetagLocked) hintForetagLocked.hidden = true;
      return;
    }

    var leveransval = getLeveransval();
    var kundtypVal = getKundtyp();
    var isButik = leveransval === 'butik';
    var hintButik = page.querySelector('[data-hint-butik]');
    var hintForetagLeverans = page.querySelector('[data-hint-foretag-leverans]');

    if (hintButik) hintButik.hidden = !isButik;
    if (hintForetagLeverans) hintForetagLeverans.hidden = kundtypVal !== 'foretag' || isButik;

    if (isButik) {
      toggleOmbudUi(false);
      setRequireOmbud(false);
      setLeveranssattUi('butik');
      return;
    }
    var showOmbud = needsOmbud(kundtypVal, leveransval);
    toggleOmbudUi(showOmbud);
    setRequireOmbud(showOmbud);
    setLeveranssattUi('leverans');
  }

  function initLeveransval() {
    var wrap = page.querySelector('[data-cart-leveransval]');
    if (!wrap) return;

    var input = getLeveransvalInput();
    var pills = wrap.querySelectorAll('[data-cart-leveransval-val]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        if (leveransvalBusy || !kundtypConfirmed) return;
        var val = pill.getAttribute('data-cart-leveransval-val');
        if (!val || (input && input.value === val)) return;

        leveransvalBusy = true;
        pills.forEach(function (p) {
          p.classList.toggle('is-selected', p.getAttribute('data-cart-leveransval-val') === val);
        });
        if (input) input.value = val;
        updateDeliveryUi();

        var attrs = { Leveransval: val };
        var chain = updateCartAttributes(attrs);

        if (val === 'butik') {
          chain = chain.then(function () {
            return updateCartAttributes({
              Leveranssätt: (getLeveranssattInput() && getLeveranssattInput().getAttribute('data-pickup-attribute')) || i18n.pickupAttribute || 'Hämta i butik',
              'DHL-ombud': '',
              'DHL-ombud-namn': '',
              'DHL-postnr': '',
              'DHL-land': ''
            });
          }).then(function () {
            var ombudInput = form && form.querySelector('[data-dhl-ombud-id]');
            if (ombudInput) ombudInput.value = '';
            resetDhlPickerUi();
            setLeveranssattUi('butik');
          }).then(function () {
            return syncCheckoutPreference('SHIPPING');
          });
        } else {
          chain = chain.then(function () {
            return clearDhlAttributes();
          }).then(function () {
            return syncCheckoutPreference('SHIPPING');
          });
        }

        chain
          .catch(function () {
            alert(i18n.saveDeliveryError || 'Kunde inte spara leveransalternativ. Försök igen.');
            refreshPage();
          })
          .finally(function () {
            leveransvalBusy = false;
          });
      });
    });
  }

  function initKundtyp() {
    var wrap = page.querySelector('[data-cart-kundtyp]');
    if (!wrap) return;

    var input = getKundtypInput();
    var pills = wrap.querySelectorAll('[data-cart-kundtyp-val]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        if (kundtypBusy) return;
        var val = pill.getAttribute('data-cart-kundtyp-val');
        if (!val) return;
        var sameVal = input && input.value === val;
        if (sameVal && kundtypConfirmed) return;

        kundtypBusy = true;
        pills.forEach(function (p) {
          p.classList.toggle('is-selected', p.getAttribute('data-cart-kundtyp-val') === val);
        });
        if (input) input.value = val;
        setKundtypConfirmed(true);

        var levInput = getLeveransvalInput();
        var defaultLeveransval = (levInput && levInput.value) ? levInput.value : 'leverans';
        if (levInput) levInput.value = defaultLeveransval;
        syncLeveransvalPills();

        var attrs = { Kundtyp: val, Leveransval: defaultLeveransval };
        var chain = updateCartAttributes(attrs);

        if (val === 'foretag') {
          chain = chain.then(function () { return clearDhlAttributes(); });
        } else {
          var nameInput = getForetagNameInput();
          var orgInput = getOrgNrInput();
          if (nameInput) nameInput.value = '';
          if (orgInput) orgInput.value = '';
          chain = chain.then(function () {
            return updateCartAttributes({ Företagsnamn: '', Organisationsnummer: '' });
          });
        }

        chain
          .catch(function () {
            alert(i18n.saveCustomerTypeError || 'Kunde inte spara kundtyp. Försök igen.');
            refreshPage();
          })
          .finally(function () {
            kundtypBusy = false;
            syncForetagFields();
          });
      });
    });
  }

  function initForetagFields() {
    var nameInput = getForetagNameInput();
    var orgInput = getOrgNrInput();
    if (!nameInput) return;

    var saveTimer;
    function scheduleSave() {
      if (!kundtypConfirmed || getKundtyp() !== 'foretag') return;
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        saveForetagAttributes().catch(function () {
          /* tyst — sparas igen vid kassa */
        });
      }, 400);
    }

    nameInput.addEventListener('input', scheduleSave);
    if (orgInput) orgInput.addEventListener('input', scheduleSave);
  }

  function initCheckoutGuard() {
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      if (giftCardOnly) {
        return;
      }

      if (!validateGiftBeforeCheckout()) {
        e.preventDefault();
        return;
      }

      if (!isSweden()) {
        // Native submit: gåvo-attributen följer med som dolda inputs i formuläret
        if (!hasStorefrontToken()) return;
        e.preventDefault();
        setLoading(true);
        syncCheckoutPreference()
          .then(function () { return saveGiftAttributes(); })
          .then(function () { return goToCheckout(); })
          .catch(function () {
            setLoading(false);
            alert(i18n.prepareDeliveryError || 'Could not prepare delivery at checkout. Try again.');
          });
        return;
      }

      if (!kundtypConfirmed) {
        e.preventDefault();
        var kundtypBlock = page.querySelector('[data-cart-kundtyp-block]');
        if (kundtypBlock) kundtypBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (!validateForetagBeforeCheckout()) {
        e.preventDefault();
        return;
      }

      var leveransval = getLeveransval();
      var requireDhl = page.getAttribute('data-require-dhl') === 'true';
      var useStorefront = hasStorefrontToken();

      if (leveransval === 'butik' || (leveransval === 'leverans' && useStorefront)) {
        e.preventDefault();
        setLoading(true);
        var method = 'SHIPPING';
        var chain = useStorefront ? syncCheckoutPreference(method) : Promise.resolve();

        chain
          .then(function () {
            if (leveransval === 'butik') {
              return saveCheckoutExtraAttributes().then(goToCheckout);
            }
            if (requireDhl) {
              var ombudInput = form.querySelector('[data-dhl-ombud-id]') || form.querySelector('input[name="attributes[DHL-ombud]"]');
              var ombudId = ombudInput && ombudInput.value ? ombudInput.value.trim() : '';
              if (!ombudId) {
                setLoading(false);
                showOmbudRequired();
                return;
              }
            }
            return saveCheckoutExtraAttributes().then(goToCheckout);
          })
          .catch(function () {
            setLoading(false);
            if (leveransval === 'butik') {
              alert(i18n.preparePickupError || 'Kunde inte förbereda hämta i butik. Försök igen.');
            } else {
              alert(i18n.prepareDeliveryError || 'Kunde inte förbereda leverans i kassan. Försök igen.');
            }
          });
        return;
      }

      if (!requireDhl) return;

      var ombudInput = form.querySelector('[data-dhl-ombud-id]') || form.querySelector('input[name="attributes[DHL-ombud]"]');
      var ombudId = ombudInput && ombudInput.value ? ombudInput.value.trim() : '';
      if (!ombudId) {
        e.preventDefault();
        showOmbudRequired();
      }
    });
  }

  initCheckoutGuard();

  if (giftCardOnly) {
    setKundtypConfirmed(true);
    setRequireOmbud(false);
  } else if (!isSweden()) {
    setKundtypConfirmed(true);
    setRequireOmbud(false);
    page.classList.remove('tambur-cart-page--no-ombud');
  } else {
    setKundtypConfirmed(page.getAttribute('data-kundtyp-explicit') === 'true');
  }

  if (staleDhlForMarket()) {
    clearDhlAttributes();
  }

  initLeveransval();
  initKundtyp();
  initForetagFields();
  syncForetagFields();
  initGiftFields();

  if (getLeveransval() === 'butik' && hasStorefrontToken()) {
    syncCheckoutPreference('SHIPPING').catch(function () { /* tyst vid sidladdning */ });
  }

  page.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      if (lineBusy) return;
      var item = qtyBtn.closest('[data-cart-line]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-cart-line'), 10);
      var qtyEl = item.querySelector('[data-cart-qty]');
      var current = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
      var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change'), 10) || 0;
      var next = current + delta;
      if (next < 0) next = 0;
      lineBusy = true;
      setLoading(true);
      changeLine(line, next)
        .then(function () { refreshPage(); })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || i18n.updateQtyError || 'Kunde inte uppdatera antal.';
          alert(msg);
          lineBusy = false;
          setLoading(false);
        });
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      if (lineBusy) return;
      var row = removeBtn.closest('[data-cart-line]');
      if (!row) return;
      var lineNum = parseInt(row.getAttribute('data-cart-line'), 10);
      lineBusy = true;
      setLoading(true);
      changeLine(lineNum, 0)
        .then(function () { refreshPage(); })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || i18n.removeError || 'Kunde inte ta bort artikeln.';
          alert(msg);
          lineBusy = false;
          setLoading(false);
        });
    }
  });
})();
